// CheckoutForm.jsx
import React, { useState } from 'react';
import { PaymentElement, LinkAuthenticationElement, useStripe, useElements } from '@stripe/react-stripe-js';

const CheckoutForm = ({ orderId }) => {
  // Save orderId in localStorage
  localStorage.setItem('orderId', orderId);

  const stripe = useStripe();
  const elements = useElements();
  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const paymentElementOptions = {
    loyout: 'tabs'
  };

  const submit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      return;
    }
    setIsLoading(true);
    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        // IMPORTANT: Point to the FRONTEND domain/port, not your backend
        // If your React app runs at http://localhost:3000:
        return_url: `http://localhost:3000/order/confirm?orderId=${orderId}`
        
        // Or if you're hosting your React app on the same domain, you can do:
        // return_url: `${window.location.origin}/order/confirm?orderId=${orderId}`
      }
    });
    if (error) {
      if (error.type === 'card_error' || error.type === 'validation_error') {
        setMessage(error.message);
      } else {
        setMessage('An unexpected error occurred');
      }
    }
    setIsLoading(false);
  };

  return (
    <form onSubmit={submit} id='payment-form'>
      <LinkAuthenticationElement id='link-authentication-element' />
      <PaymentElement id='payment-element' options={paymentElementOptions} />
      <button
        disabled={isLoading || !stripe || !elements}
        id='submit'
        className='px-10 py-[6px] rounded-sm hover:shadow-orange-500/20 hover:shadow-lg bg-orange-500 text-white'
      >
        <span id='button-text'>
          {isLoading ? <div>Loading.....</div> : "Pay now"}
        </span>
      </button>
      {message && <div>{message}</div>}
    </form>
  );
};

export default CheckoutForm;
